import defaultTexts from './data/defaultTexts.json';

export default class MulLangTexts {
  constructor() {
    this._texts = defaultTexts.dynamic;
    this._targetAttributes = ['placeholder', 'label'];
  }
  _replaceTextNode(node, texts) {
    for(const attr of this._targetAttributes) {
      const text = texts[node[attr]];
      if(text) node[attr] = text;
    }
    if(node.dataset && node.dataset.langLabel) {
      node.textContent = texts[node.dataset.langLabel];
    } else if(node.hasChildNodes()) {
      for(const child of node.childNodes) {
        this._replaceTextNode(child, texts);
      }
    } else if(node.nodeName === '#text') {
      if(texts[node.textContent]) {
        node.textContent = texts[node.textContent];
      }
    }
  }
  async init() {
    const lang = navigator.language;
    const sub = lang.slice(0, 2);
    const res = await fetch('./supportedLangs.json');
    const supportedLangs = await res.json();
    
    let htmlLang = null;
    if(supportedLangs.main.indexOf(lang) !== -1) {
      htmlLang = lang;
    } else if(supportedLangs.main.indexOf(sub) !== -1) {
      htmlLang = sub;
    }

    let helps = null;
    if(htmlLang) {
      const res = await fetch(`./texts/${htmlLang}.json`);
      const texts = await res.json();
      this._replaceTextNode(document.body, texts.static);
      this._texts = Object.assign(this._texts, texts.dynamic);
      if(texts.font) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = texts.font.href;
        document.head.appendChild(link);
        document.body.style.fontFamily = `"${texts.font.name}","Comic Sans MS",sans-serif`;
      }
      helps = texts.helps;
    }

    return {helps};
  }
  get(key) {
    if(key in this._texts) {
      return this._texts[key];
    } else {
      return key;
    }
  }
  replaceTextNode(node) {
    this._replaceTextNode(node, this._texts);
  }
}
